import { parseDateEnLocale } from '@zorro/shared/formatters';

export const DEFAULT_ADULT_DATE = '01/01/1990';

export function getAdultDefaultDate(): Date {
  return parseDateEnLocale(DEFAULT_ADULT_DATE).toDate();
}
